export class SpaURL extends URL {
  constructor(url: string) {
    super(`${window.location.origin}${url}`)
  }

  toString(): string {
    const url = super.toString()
    return url.replaceAll(window.location.origin, '')
  }
}
